import React, { useState, useRef } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';

const MaterialTab = ({
  tiposMateriais,
  isLoading,
  showModal,
  handleCloseModal,
  handleOpenModal,
  handleToggleStatus,
  mostrarInativos,
  setMostrarInativos,
  handleOpenMergeModal,
  novoMaterial,
  handleChange,
  handleSubmit,
  getQuantidadeEmEstoque,
}) => {
  const [activeModalTabKey, setActiveModalTabKey] = useState('dadosBasicos');
  const [actionsOpen, setActionsOpen] = useState(false);
  const actionsRef = useRef(null);

  // Fecha o dropdown ao clicar fora
  React.useEffect(() => {
    const handleClick = (e) => {
      if (actionsRef.current && !actionsRef.current.contains(e.target)) {
        setActionsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const unidadesDeMedida = [
    { valor: '', rotulo: 'Selecione...' },
    { valor: 'Unidade', rotulo: 'Unidade' },
    { valor: 'Grama', rotulo: 'Grama' },
    { valor: 'Ml', rotulo: 'Ml' },
    { valor: 'Quilo', rotulo: 'Quilo' },
    { valor: 'Metro', rotulo: 'Metro' },
    { valor: 'Metro Cúbico', rotulo: 'Metro Cúbico' },
  ];

  const fieldStyle = {
    width: '100%', padding: '9px 12px', borderRadius: '8px',
    border: '1px solid #e5e7eb', fontSize: '13px', color: '#374151',
    fontFamily: "'Inter', 'Segoe UI', sans-serif", outline: 'none',
    backgroundColor: '#fff', transition: 'border-color 0.15s, box-shadow 0.15s',
  };

  const labelStyle = {
    fontSize: '11px', fontWeight: '700', color: '#6b7280',
    textTransform: 'uppercase', letterSpacing: '0.5px',
    display: 'block', marginBottom: '5px',
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
  };

  const handleFieldFocus = (e) => {
    e.target.style.borderColor = '#3b82f6';
    e.target.style.boxShadow = '0 0 0 3px rgba(59,130,246,0.1)';
  };
  const handleFieldBlur = (e) => {
    e.target.style.borderColor = '#e5e7eb';
    e.target.style.boxShadow = 'none';
  };

  return (
    <div style={{ fontFamily: "'Inter', 'Segoe UI', sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
        .material-table { width: 100%; border-collapse: collapse; }
        .material-table thead tr {
          background: linear-gradient(135deg, #f8fafc, #f1f5f9);
          border-bottom: 2px solid #e2e8f0;
        }
        .material-table thead th {
          padding: 12px 16px; font-size: 11px; font-weight: 700;
          color: #64748b; text-transform: uppercase; letter-spacing: 0.5px;
          white-space: nowrap; font-family: 'Inter', 'Segoe UI', sans-serif;
        }
        .material-table tbody tr {
          border-bottom: 1px solid #f1f5f9; transition: background 0.15s;
        }
        .material-table tbody tr:hover { background: #f8fafc; }
        .material-table tbody td {
          padding: 12px 16px; font-size: 13px; color: #374151;
          vertical-align: middle; font-family: 'Inter', 'Segoe UI', sans-serif;
        }
        .modal-tab-btn {
          padding: 10px 16px; border: none; background: none;
          font-size: 13px; font-weight: 500; color: #6b7280;
          border-bottom: 2px solid transparent; cursor: pointer;
          transition: all 0.15s; white-space: nowrap;
          font-family: 'Inter', 'Segoe UI', sans-serif;
        }
        .modal-tab-btn:hover { color: #374151; }
        .modal-tab-btn.active { color: #3b82f6; border-bottom-color: #3b82f6; font-weight: 600; }
        @keyframes dropdownFadeIn {
          from { opacity: 0; transform: translateY(-4px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {/* ── BARRA DE AÇÕES ── */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px', flexWrap: 'wrap', gap: '10px' }}>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          {/* Botão Novo Material */}
          <button
            onClick={handleOpenModal}
            style={{
              padding: '8px 16px', borderRadius: '8px', border: 'none',
              background: 'linear-gradient(135deg, #1e3a5f, #2563eb)',
              color: '#fff', fontSize: '13px', fontWeight: '600',
              cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px',
              fontFamily: 'inherit', boxShadow: '0 2px 8px rgba(37,99,235,0.3)',
              transition: 'opacity 0.15s',
            }}
            onMouseEnter={e => e.currentTarget.style.opacity = '0.9'}
            onMouseLeave={e => e.currentTarget.style.opacity = '1'}
          >
            <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            Novo Material
          </button>

          {/* Dropdown Ações */}
          <div ref={actionsRef} style={{ position: 'relative' }}>
            <button
              onClick={() => setActionsOpen(!actionsOpen)}
              style={{
                padding: '8px 14px', borderRadius: '8px',
                border: '1px solid #e5e7eb', backgroundColor: '#fff',
                color: '#374151', fontSize: '13px', fontWeight: '500',
                cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px',
                fontFamily: 'inherit', transition: 'background 0.15s',
              }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f9fafb'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = '#fff'}
            >
              Ações
              <svg width="12" height="12" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ transition: 'transform 0.15s', transform: actionsOpen ? 'rotate(180deg)' : 'rotate(0)' }}>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {actionsOpen && (
              <div style={{
                position: 'absolute', top: 'calc(100% + 6px)', left: 0,
                backgroundColor: '#fff', borderRadius: '10px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                minWidth: '220px', zIndex: 100,
                animation: 'dropdownFadeIn 0.15s ease',
                overflow: 'hidden',
              }}>
                <button
                  onClick={() => { handleOpenMergeModal(); setActionsOpen(false); }}
                  style={{
                    width: '100%', padding: '10px 16px', border: 'none',
                    background: 'none', textAlign: 'left', cursor: 'pointer',
                    fontSize: '13px', color: '#374151', fontFamily: 'inherit',
                    display: 'flex', alignItems: 'center', gap: '10px',
                    transition: 'background 0.1s',
                  }}
                  onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f9fafb'}
                  onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                  <svg width="14" height="14" fill="none" stroke="#9ca3af" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                  </svg>
                  Unificar Tipos de Materiais
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Switch mostrar inativos */}
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px', color: '#6b7280', fontFamily: 'inherit' }}>
          <div
            onClick={() => setMostrarInativos(!mostrarInativos)}
            style={{
              width: '40px', height: '22px', borderRadius: '999px',
              backgroundColor: mostrarInativos ? '#3b82f6' : '#d1d5db',
              cursor: 'pointer', position: 'relative', transition: 'background 0.2s', flexShrink: 0,
            }}
          >
            <div style={{
              position: 'absolute', top: '3px',
              left: mostrarInativos ? '21px' : '3px',
              width: '16px', height: '16px', borderRadius: '50%',
              backgroundColor: '#fff', transition: 'left 0.2s',
              boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
            }} />
          </div>
          Mostrar inativos
        </label>
      </div>

      {/* ── TABELA DE MATERIAIS ── */}
      {isLoading ? (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '60px', color: '#6b7280', fontSize: '13px' }}>
          <Spinner animation="border" size="sm" variant="primary" />
          Carregando materiais...
        </div>
      ) : tiposMateriais.length === 0 ? (
        <div style={{
          textAlign: 'center', padding: '60px 24px',
          backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e5e7eb',
        }}>
          <svg width="48" height="48" fill="none" stroke="#d1d5db" viewBox="0 0 24 24" style={{ display: 'block', margin: '0 auto 16px' }}>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
          </svg>
          <p style={{ margin: 0, fontSize: '14px', color: '#9ca3af' }}>
            {mostrarInativos ? 'Nenhum material inativo encontrado.' : 'Nenhum material cadastrado.'}
          </p>
        </div>
      ) : (
        <div style={{
          backgroundColor: '#fff', borderRadius: '12px',
          border: '1px solid #e5e7eb', overflow: 'hidden',
          boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        }}>
          <table className="material-table">
            <thead>
              <tr>
                <th>Nome</th>
                <th className="d-none d-md-table-cell">Descrição</th>
                <th style={{ textAlign: 'center' }}>Unidade</th>
                <th style={{ textAlign: 'center' }}>Qtd. em Estoque</th>
                <th style={{ textAlign: 'center' }}>Status</th>
                <th style={{ textAlign: 'center' }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {tiposMateriais.map((tipoMaterial) => {
                const qtd = getQuantidadeEmEstoque(tipoMaterial.id);
                return (
                  <tr key={tipoMaterial.id} style={{ opacity: mostrarInativos ? 0.75 : 1 }}>
                    {/* Nome */}
                    <td>
                      <div style={{ fontWeight: '600', color: '#111827' }}>{tipoMaterial.nome}</div>
                    </td>

                    {/* Descrição */}
                    <td className="d-none d-md-table-cell" style={{ color: '#6b7280', maxWidth: '200px' }}>
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>
                        {tipoMaterial.descricao || <span style={{ color: '#d1d5db', fontStyle: 'italic' }}>—</span>}
                      </span>
                    </td>

                    {/* Unidade */}
                    <td style={{ textAlign: 'center' }}>
                      <span style={{
                        padding: '2px 8px', borderRadius: '999px', fontSize: '11px', fontWeight: '600',
                        backgroundColor: '#f3f4f6', color: '#6b7280',
                      }}>
                        {tipoMaterial.unidade_medida || '—'}
                      </span>
                    </td>

                    {/* Quantidade */}
                    <td style={{ textAlign: 'center' }}>
                      <span style={{
                        fontSize: '16px', fontWeight: '700',
                        color: qtd <= 0 ? '#ef4444' : '#111827',
                      }}>
                        {qtd}
                      </span>
                      {tipoMaterial.unidade_medida && (
                        <span style={{ fontSize: '11px', color: '#9ca3af', marginLeft: '4px' }}>
                          {tipoMaterial.unidade_medida}
                        </span>
                      )}
                    </td>

                    {/* Status */}
                    <td style={{ textAlign: 'center' }}>
                      <span style={{
                        display: 'inline-flex', alignItems: 'center', gap: '5px',
                        padding: '3px 10px', borderRadius: '999px', fontSize: '11px', fontWeight: '600',
                        backgroundColor: mostrarInativos ? '#f3f4f6' : '#f0fdf4',
                        color: mostrarInativos ? '#6b7280' : '#16a34a',
                        border: `1px solid ${mostrarInativos ? '#e5e7eb' : '#bbf7d0'}`,
                      }}>
                        <span style={{
                          width: '6px', height: '6px', borderRadius: '50%', flexShrink: 0,
                          backgroundColor: mostrarInativos ? '#9ca3af' : '#22c55e',
                        }} />
                        {mostrarInativos ? 'Inativo' : 'Ativo'}
                      </span>
                    </td>

                    {/* Ações */}
                    <td style={{ textAlign: 'center' }}>
                      <button
                        onClick={() => handleToggleStatus(tipoMaterial.id)}
                        style={{
                          padding: '6px 12px', borderRadius: '6px', border: 'none',
                          background: mostrarInativos ? '#f0fdf4' : '#fef2f2',
                          color: mostrarInativos ? '#16a34a' : '#dc2626',
                          fontSize: '12px', fontWeight: '600',
                          cursor: 'pointer', fontFamily: 'inherit',
                          display: 'inline-flex', alignItems: 'center', gap: '5px',
                          transition: 'opacity 0.15s',
                        }}
                        onMouseEnter={e => e.currentTarget.style.opacity = '0.8'}
                        onMouseLeave={e => e.currentTarget.style.opacity = '1'}
                      >
                        {mostrarInativos ? (
                          <>
                            <svg width="12" height="12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            Reativar
                          </>
                        ) : (
                          <>
                            <svg width="12" height="12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                            </svg>
                            Inativar
                          </>
                        )}
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* ══════════════════════════════════════════════════════════
          MODAL: CRIAR NOVO MATERIAL
      ══════════════════════════════════════════════════════════ */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header style={{ padding: '0', border: 'none' }}>
          <div style={{
            width: '100%', padding: '20px 24px',
            background: 'linear-gradient(135deg, #1e3a5f, #2563eb)',
            display: 'flex', alignItems: 'center', gap: '12px',
          }}>
            <div style={{
              width: '40px', height: '40px', borderRadius: '10px',
              backgroundColor: 'rgba(255,255,255,0.2)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            }}>
              <svg width="20" height="20" fill="none" stroke="white" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
              </svg>
            </div>
            <div style={{ fontSize: '15px', fontWeight: '700', color: '#fff', flex: 1 }}>
              Criar Novo Material
            </div>
            {/* Botão fechar customizado */}
            <button
              onClick={handleCloseModal}
              style={{
                width: '28px', height: '28px', borderRadius: '6px',
                border: '1px solid rgba(255,255,255,0.3)',
                backgroundColor: 'rgba(255,255,255,0.15)',
                color: '#fff', cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '16px', lineHeight: 1, flexShrink: 0,
                transition: 'background 0.15s',
              }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.25)'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.15)'}
            >
              ×
            </button>
          </div>
        </Modal.Header>

        <Modal.Body style={{ padding: '0', backgroundColor: '#f9fafb' }}>
          {/* Abas do modal */}
          <div style={{
            borderBottom: '1px solid #e5e7eb', backgroundColor: '#fff',
            display: 'flex', padding: '0 20px',
          }}>
            {[
              { key: 'dadosBasicos', label: 'Dados Básicos' },
              { key: 'dadosAdicionais', label: 'Dados Adicionais' },
            ].map(tab => (
              <button
                key={tab.key}
                className={`modal-tab-btn ${activeModalTabKey === tab.key ? 'active' : ''}`}
                onClick={() => setActiveModalTabKey(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* Conteúdo das abas */}
          <div style={{ padding: '20px', maxHeight: '60vh', overflowY: 'auto' }}>

            {/* ABA: Dados Básicos */}
            {activeModalTabKey === 'dadosBasicos' && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>

                {/* Nome */}
                <div>
                  <label style={labelStyle}>Nome *</label>
                  <input
                    type="text"
                    name="nome"
                    value={novoMaterial.nome}
                    onChange={handleChange}
                    placeholder="Nome do material"
                    style={fieldStyle}
                    onFocus={handleFieldFocus}
                    onBlur={handleFieldBlur}
                    required
                  />
                </div>

                {/* Descrição */}
                <div>
                  <label style={labelStyle}>Descrição</label>
                  <input
                    type="text"
                    name="descricao"
                    value={novoMaterial.descricao}
                    onChange={handleChange}
                    placeholder="Descrição breve do material"
                    style={fieldStyle}
                    onFocus={handleFieldFocus}
                    onBlur={handleFieldBlur}
                  />
                </div>

                {/* Unidade de Medida */}
                <div>
                  <label style={labelStyle}>Unidade de Medida *</label>
                  <select
                    name="unidade_medida"
                    value={novoMaterial.unidade_medida || ''}
                    onChange={handleChange}
                    required
                    style={fieldStyle}
                    onFocus={handleFieldFocus}
                    onBlur={handleFieldBlur}
                  >
                    {unidadesDeMedida.map(unidade => (
                      <option key={unidade.valor} value={unidade.valor}>
                        {unidade.rotulo}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Valor Total + Quantidade (grid) */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  <div>
                    <label style={labelStyle}>Valor Total (R$)</label>
                    <CurrencyInput
                      id="valorMaterialTabInput"
                      name="valor"
                      className="form-control"
                      placeholder="R$ 0,00"
                      defaultValue={novoMaterial.valor || 0}
                      decimalsLimit={2}
                      decimalSeparator=","
                      groupSeparator="."
                      prefix="R$ "
                      onValueChange={(value, name) => handleChange({ target: { value, name } }, name)}
                      style={{ ...fieldStyle, width: '100%' }}
                    />
                  </div>
                  <div>
                    <label style={labelStyle}>Quantidade Adquirida *</label>
                    <input
                      type="number"
                      name="quantidade_adquirida"
                      value={novoMaterial.quantidade_adquirida}
                      onChange={handleChange}
                      min="0"
                      required
                      style={fieldStyle}
                      onFocus={handleFieldFocus}
                      onBlur={handleFieldBlur}
                    />
                  </div>
                </div>

                {/* Valor Unitário (calculado) */}
                <div>
                  <label style={labelStyle}>Valor Unitário (calculado)</label>
                  <div style={{
                    padding: '9px 12px', borderRadius: '8px',
                    border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',
                    fontSize: '13px', color: '#374151',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  }}>
                    <span style={{ color: '#9ca3af', fontSize: '12px' }}>Calculado automaticamente</span>
                    <span style={{ fontWeight: '700', color: '#111827' }}>
                      R$ {Number(novoMaterial.valor_unidade || 0).toFixed(2).replace('.', ',')}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {/* ABA: Dados Adicionais */}
            {activeModalTabKey === 'dadosAdicionais' && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>

                {/* Fornecedor + Fabricante */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  <div>
                    <label style={labelStyle}>Fornecedor</label>
                    <input
                      type="text"
                      name="fornecedor"
                      value={novoMaterial.fornecedor}
                      onChange={handleChange}
                      style={fieldStyle}
                      onFocus={handleFieldFocus}
                      onBlur={handleFieldBlur}
                      placeholder="Nome do fornecedor"
                    />
                  </div>
                  <div>
                    <label style={labelStyle}>Fabricante</label>
                    <input
                      type="text"
                      name="fabricante"
                      value={novoMaterial.fabricante}
                      onChange={handleChange}
                      style={fieldStyle}
                      onFocus={handleFieldFocus}
                      onBlur={handleFieldBlur}
                      placeholder="Nome do fabricante"
                    />
                  </div>
                </div>

                {/* Número de Série + Lote */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  <div>
                    <label style={labelStyle}>Número de Série</label>
                    <input
                      type="text"
                      name="numero_serie"
                      value={novoMaterial.numero_serie}
                      onChange={handleChange}
                      style={fieldStyle}
                      onFocus={handleFieldFocus}
                      onBlur={handleFieldBlur}
                    />
                  </div>
                  <div>
                    <label style={labelStyle}>Lote</label>
                    <input
                      type="text"
                      name="lote"
                      value={novoMaterial.lote}
                      onChange={handleChange}
                      style={fieldStyle}
                      onFocus={handleFieldFocus}
                      onBlur={handleFieldBlur}
                    />
                  </div>
                </div>

                {/* Validade */}
                <div>
                  <label style={labelStyle}>Validade</label>
                  <input
                    type="date"
                    name="validade"
                    value={novoMaterial.validade}
                    onChange={handleChange}
                    style={fieldStyle}
                    onFocus={handleFieldFocus}
                    onBlur={handleFieldBlur}
                  />
                </div>

                {/* Divider */}
                <div style={{ height: '1px', backgroundColor: '#f3f4f6', margin: '4px 0' }} />

                {/* Estoque Mínimo + Máximo */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  <div>
                    <label style={labelStyle}>Estoque Mínimo *</label>
                    <input
                      type="number"
                      name="estoque_minimo"
                      value={novoMaterial.estoque_minimo}
                      onChange={handleChange}
                      min="0"
                      required
                      style={fieldStyle}
                      onFocus={handleFieldFocus}
                      onBlur={handleFieldBlur}
                    />
                    <p style={{ fontSize: '11px', color: '#9ca3af', marginTop: '4px', marginBottom: 0 }}>
                      Alerta quando atingir este valor
                    </p>
                  </div>
                  <div>
                    <label style={labelStyle}>Estoque Máximo</label>
                    <input
                      type="number"
                      name="estoque_maximo"
                      value={novoMaterial.estoque_maximo}
                      onChange={handleChange}
                      min="0"
                      style={fieldStyle}
                      onFocus={handleFieldFocus}
                      onBlur={handleFieldBlur}
                    />
                    <p style={{ fontSize: '11px', color: '#9ca3af', marginTop: '4px', marginBottom: 0 }}>
                      Opcional
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer style={{ borderTop: '1px solid #e5e7eb', padding: '12px 20px', gap: '8px', backgroundColor: '#fff' }}>
          <button
            onClick={handleCloseModal}
            style={{
              padding: '8px 16px', borderRadius: '8px', border: '1px solid #e5e7eb',
              backgroundColor: '#fff', color: '#374151', cursor: 'pointer',
              fontSize: '13px', fontWeight: '500', fontFamily: 'inherit',
            }}
          >
            Cancelar
          </button>
          <button
            onClick={handleSubmit}
            disabled={isLoading}
            style={{
              padding: '8px 20px', borderRadius: '8px', border: 'none',
              background: isLoading ? '#93c5fd' : 'linear-gradient(135deg, #1e3a5f, #2563eb)',
              color: '#fff', cursor: isLoading ? 'not-allowed' : 'pointer',
              fontSize: '13px', fontWeight: '600', fontFamily: 'inherit',
              display: 'flex', alignItems: 'center', gap: '8px',
              boxShadow: isLoading ? 'none' : '0 2px 8px rgba(37,99,235,0.3)',
            }}
          >
            {isLoading && (
              <Spinner as="span" animation="border" size="sm" style={{ width: '14px', height: '14px', borderWidth: '2px' }} />
            )}
            {isLoading ? 'Salvando...' : 'Salvar Material'}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default MaterialTab;
